import AIFlaggedIssueViewModel from "../Filtering/QAFilters/ViewModels/AIFlaggedIssueViewModel";
import SalesAIAnswerViewModel from "../Filtering/QAFilters/ViewModels/SalesAIAnswerViewModel";
import ScorecardAnswersViewModel from "../Filtering/QAFilters/ViewModels/ScorecardAnswersViewModel";
import ScorecardScoreViewModel from "../Monitoring/ViewModels/ScorecardScoreViewModel";
import { AINotesViewModel } from "./AINotesViewModel";
import CallTableViewModel from "./CallTableViewModel";

export class IndexViewModel { //still in use?
    public filters: FilterViewModel = new FilterViewModel;
    public callrows: CallRowViewModel[] = [];
}

export class NewIndexViewModel {
    public callTableViewModel: CallTableViewModel = new CallTableViewModel;
    public callRows: CallRowViewModel[] = [];
    public similarWords: string[] = [];
}

export class AgentViewIndexViewModel {
    public filters: FilterViewModel = new FilterViewModel;
    public callrows: AgentViewRowViewModel[] = [];
}
export class FilterViewModel {
    public flagOtherAgent: boolean = false;
    public flagActionType: boolean = false;
    public flagClient: boolean = true;
    public flagToday: boolean = false;
    public flagYesterday: boolean = false;
    public flagThisWeek: boolean = false;
    public flagLastWeek: boolean = false;
    public flagThisMonth: boolean = false;
    public flagLastMonth: boolean = false;
    public flagSingleDate: boolean = false;
    public flagDateRange: boolean = false;
    public flagTimeRange: boolean = false;
    public flagSite: boolean = false;
    public flagChannel: boolean = false;
    public flagTeamLeader: boolean = false;
    public flagAgentName: boolean = false;
    public flagResultContains: boolean = false;
    public flagResultExcluding: boolean = false;
    public flagSale: boolean = false;
    public flagNoSale: boolean = false;
    public flagResultSource: boolean = false;
    public flagCallLength: boolean = false;
    public flagVoiceOfTheCustomer: boolean = false;
    public flagCustomerID: boolean = false;
    public flagClientRef: boolean = false;
    public flagURN: boolean = false;
    public flagTelephone: boolean = false;
    public flagContainsReportCode1: boolean = false;
    public flagContainsReportCode2: boolean = false;
    public flagContainsReportCode3: boolean = false;
    public flagContainsReportCode5: boolean = false;
    public flagExcludesReportCode1: boolean = false;
    public flagExcludesReportCode2: boolean = false;
    public flagExcludesReportCode3: boolean = false;
    public flagExcludesReportCode5: boolean = false;
    public flagRandomSelection: boolean = false;
    public flagRandomPerAgent: boolean = false;
    public flagSystemID: boolean = false;
    public flagTag: boolean = false;
    public flagRTM: boolean = false;
    public flagDates: boolean = false;
    public flagMonitoringStatus: boolean = false;
    public flagMonitoredBy: boolean = false;
    public flagMonitoringResult: boolean = false;
    public flagAlert: boolean = false;
    public flagResQMonitoringResult: boolean = false;
    public flagStandardSearch: boolean = true;
    public flagCustomerTranscriptSearch: boolean = false;
    public flagAgentTranscriptSearch: boolean = false;
    public flagPhraseSearch: boolean = false;
    public flagWordSearch: boolean = false;
    public flagInflectionSearch: boolean = false;
    public flagAgentSentimentStart: boolean = false;
    public flagAgentSentimentEnd: boolean = false;
    public flagAgentSentimentAverage: boolean = false;
    public flagCustomerSentimentStart: boolean = false;
    public flagCustomerSentimentEnd: boolean = false;
    public flagCustomerSentimentAverage: boolean = false;
    public flagAnySearch: boolean = false;
    public flagVulnerability: boolean = false;
    public flagComplaint: boolean = false;
    public flagVulnerabilityCategory: boolean = false;
    public flagComplaintCategory: boolean = false;
    public flagAllVulnerabilities: boolean = false;
    public flagAllComplaints: boolean = false;
    public flagAbilityGroup: boolean = false;
    public flagSaleType: boolean = false;
    public flagProduct: boolean = false;
    public flagProductType: boolean = false;
    public flagProductOffer: boolean = false;
    public flagProductReference: boolean = false;
    public flagAIFlaggedIssues: boolean = false;
    public flagScorecardAnswers: boolean = false;
    public flagSalesAI: boolean = false;


    public actionType?: string = undefined;
    public client?: string = undefined;
    public startDate: Date = new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24);
    public endDate: Date = new Date((new Date()).valueOf() - 1000 * 60 * 60 * 24);
    public startTime?: string = undefined;
    public endTime?: string = undefined;
    public site?: string = '';
    public channel?: string = '';
    public teamLeader: string[] = [];
    public agentName: string[] = [];
    public resultsInclude: string[] = [];
    public resultsExclude: string[] = [];
    public resultSource?: string = '';
    public callLengthMin: number = 0;
    public callLengthMax: number = 606;
    public customerID?: string = '';
    public clientRef?: string = '';
    public urn?: string = '';
    public telephone?: string = '';
    public containsRepCode1?: string[] = [];
    public containsRepCode2?: string[] = [];
    public containsRepCode3?: string[] = [];
    public containsRepCode5?: string[] = [];
    public excludesRepCode1?: string[] = [];
    public excludesRepCode2?: string[] = [];
    public excludesRepCode3?: string[] = [];
    public excludesRepCode5?: string[] = [];
    public randCount: number = 0;
    public randCountPerAgent: number = 0;
    public systemID?: string = '';
    public tagsInclude: string[] = [];
    public pageNumber: number = 0;
    public pageCount: number;
    public count: number;
    public weekday: string = 'SUN';
    public rowsPerPage: number = 20;
    public orderBy: string = "";
    public monitoringStatus: string = "";
    public monitoredBy: string[] = [];
    public alert: string = "";
    public monitoringResult: string = "";
    public resQMonitoringResult: string = "";
    public transcriptSearch: string = "";
    public agentSentimentStart: string[] = [];
    public agentSentimentEnd: string[] = [];
    public agentSentimentAverage: string[] = [];
    public customerSentimentStart: string[] = [];
    public customerSentimentEnd: string[] = [];
    public customerSentimentAverage: string[] = [];
    // Similar words to those provided in the transcript search
    public similarWords: string[] = [];
    public vulnerability: string[] = [];
    public complaint: string[] = [];
    public vulnerabilityCategory: string[] = [];
    public complaintCategory: string[] = [];
    public abilityGroup: string[] = [];
    public saleType: string[] = [];
    public product: string[] = [];
    public productType: string[] = [];
    public productOffer: string[] = [];
    public productReference: string = "";
    public aiFlaggedIssues: AIFlaggedIssueViewModel = new AIFlaggedIssueViewModel();
    public scorecardAnswer: ScorecardAnswersViewModel = new ScorecardAnswersViewModel();
    public salesAIAnswer: SalesAIAnswerViewModel = new SalesAIAnswerViewModel();
}
export default class AgentViewRowViewModel {
    callRefId: string;
    completeId: number;
    customerId: string;
    customerName: string;
    result: string;
    direction: string;
    customerSentimentEnd?: number;
    phoneNumber: string;
    scorecardStatus: string;
    eventTime: string;
    callLength: string;
}
export class CallRowViewModel {
    public eventTime: Date;
    public callLength: number = 0;

    public client: string = "";
    public agentName: string = "";
    public channel: string = "";
    public site: string = "";
    public teamLeader: string = "";
    public result: string = "";
    public type: string = "";
    public reportCode1: string = "";
    public reportCode1Description: string = "";
    public reportCode2: string = "";
    public reportCode3: string = "";
    public reportCode3Description: string = "";
    public customerID: string = "";
    public telephone: string = "";
    public systemID: string = "";
    public systemPK: string = "";
    public team: string = "";
    public payrollNumber: number = 0;
    public platform: string = "";
    public callReason: string = "";
    public callCategory: string = "";
    public saleType: string = "";
    public product: string = "";
    public productType: string = "";
    public productOffer: string = "";
    public complaintCategory: string = "";
    public complaint: string = "";
    public vulnerabilityCategory: string = "";
    public vulnerability: string = "";
    public score: ScorecardScoreViewModel = new ScorecardScoreViewModel();
    public clientReference: string = "";
    public recordingStatusDescription: string = "";
    public recordingStatusColour: string = "";
    public scorecardStatus: string = "";
    public scorecardCritFail: boolean = false;
    public customerSentimentEnd?: number;
    public theme: string = "";
    public outcome: string = "";
    public originator: string = "";

    public aiNotes: AINotesViewModel = new AINotesViewModel();
    public notesFlag: boolean = false;
    public tagsFlag: boolean = false;
    public ncFlag: boolean = false;
    public ansFlag: boolean = false;

    public tagIDs: number[] = [];
}

export class FilterListViewModel {
    public displayName: string;
    public flagName: string;
    public valueNames: string[];
    public valueType: string;
    public listValues?: string;
    public step?: number;
}
